module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="base-league-data '+
((__t=( (current_user_id == id)?'current-user-team':'' ))==null?'':_.escape(__t))+
' '+
((__t=( status ))==null?'':_.escape(__t))+
'">\n	<div class="table-item">\n		<span class="rank">\n			'+
((__t=( rank ))==null?'':_.escape(__t))+
'\n		</span>\n	</div>\n	<div class="table-item avatar">\n		<img src="'+
((__t=( avatar ))==null?'':_.escape(__t))+
'" />\n	</div>\n	<div class="table-item name">\n		<div class="team-name">\n			'+
((__t=( tipping_team_name ))==null?'':_.escape(__t))+
'\n		</div>\n	</div>\n	<div class="table-item">\n		'+
((__t=( streak ))==null?'':_.escape(__t))+
'\n	</div>\n	<div class="table-item">\n		'+
((__t=( total_margin ))==null?'':_.escape(__t))+
'\n	</div>\n</div>\n';
}
return __p;
};
